import React, { useEffect, useState } from 'react'
import { ComboboxProps, MultiSelectCombobox } from './combobox'
import { getFiltersFromUrl, setFilterValue } from 'uiComponents/filter/filterHelpers'
import { FilterCategory } from 'uiComponents/filter/schema'
import { useNavigation } from 'hocs'

interface ComboboxFilterProps extends Omit<ComboboxProps, 'value' | 'onChange'> {
    filterCategory: FilterCategory
}

export const ComboboxFilter = ({ filterCategory, ...props }: ComboboxFilterProps) => {
    const navigation = useNavigation()
    const [value, setValue] = useState<string[]>()

    useEffect(() => {
        const valueFromUrl = getFiltersFromUrl(filterCategory)
        setValue(valueFromUrl.split(','))
    }, [location.search, filterCategory])

    const handleChange = (value: string[]) => {
        const valueString = value.join(',')
        setFilterValue(filterCategory, valueString, navigation)
    }

    return <MultiSelectCombobox value={value} {...props} onChange={handleChange} />
}

export default ComboboxFilter
